module.exports = __webpack_public_path__ + "img/vehicles-group.f85e0c1f.svg";